module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/icon-check-v2.db8d3e0f.svg";